import {
  SYSTEM_SALARYTYPE_MODAL_CHANGE,
} from './constants';

export function salaryTypeModalChange(visible,type) {
  return {
    type: SYSTEM_SALARYTYPE_MODAL_CHANGE,
    data: {visible,type},
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SYSTEM_SALARYTYPE_MODAL_CHANGE:
      return {
        ...state,
        salaryTypeModalType:action.data.type,
        salaryTypeModalVisible:action.data.visible
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/system/redux/salaryTypeModalChange.js